import { Helmet } from "react-helmet-async";
import React from "react";
import { useIntl } from "react-intl";
import { getStoreCodeUrl } from "@Src_main/extensions/store-url-resolver/storeUrlResolver";
import { env } from "build/env";
export var urlPageForSchema = (prefix, url) => "".concat(prefix, "/").concat(getStoreCodeUrl(), "/").concat(url, "/");
export var SchemaSiteNavigationElement = () => {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify({
    "@context": "http://schema.org",
    "@type": "SiteNavigationElement",
    name: ["".concat(intl.formatMessage({
      id: "header.menu.menu_ristorante.title",
      defaultMessage: "Menu ristorante"
    })), "".concat(intl.formatMessage({
      id: "header.menu.sfida.title",
      defaultMessage: "La nostra sfida"
    })), "".concat(intl.formatMessage({
      id: "header.menu.produttori.title",
      defaultMessage: "Produttori"
    })), "".concat(intl.formatMessage({
      id: "header.menu.farm.title",
      defaultMessage: "Miscusi farm"
    })), "".concat(intl.formatMessage({
      id: "header.menu.nostro_percorso.title",
      defaultMessage: "Il nostro Percorso"
    })), "".concat(intl.formatMessage({
      id: "header.menu.eventi.title",
      defaultMessage: "Eventi"
    })), "".concat(intl.formatMessage({
      id: "header.menu.giornale.title",
      defaultMessage: "Giornale"
    })), "".concat(intl.formatMessage({
      id: "header.menu.lavora_con_noi.title",
      defaultMessage: "Lavora con noi"
    }))],
    url: [urlPageForSchema(env.URL_MISCUSI, "menu-ristorante"), urlPageForSchema(env.URL_MISCUSI, "la-nostra-sfida"), urlPageForSchema(env.URL_MISCUSI, "makers"), urlPageForSchema(env.URL_MISCUSI, "miscusi-farm"), urlPageForSchema(env.URL_MISCUSI, "il-nostro-percorso"), urlPageForSchema(env.URL_MISCUSI, "eventi"), urlPageForSchema(env.URL_MISCUSI, "blog"), urlPageForSchema(env.URL_MISCUSI, "lavora-con-noi")]
  })));
};
export var SchemaSiteNavigationElementTakeaway = () => {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify({
    "@context": "http://schema.org",
    "@type": "SiteNavigationElement",
    name: ["".concat(intl.formatMessage({
      id: "header.menu.menu_ristorante.title",
      defaultMessage: "Menu ristorante"
    }))],
    url: [urlPageForSchema(env.URL_MISCUSI, "menu-ristorante")]
  })));
};